module.exports = __webpack_public_path__ + "static/br-91b730a698610318262a71d1123590f5.png";